import appSettings from "@/appsettings.json";
import { loadStripe, type Stripe } from "@stripe/stripe-js";

export const stripePromise: Promise<Stripe | null> = appSettings.StripePublishableKey
	? loadStripe(appSettings.StripePublishableKey)
	: Promise.resolve(null);

export const isStripeConfigured = Boolean(appSettings.StripePublishableKey);